var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageRegisterOrderIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 435.385,
    height: 385.801,
    viewBox: "0 0 435.385 385.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2910",
    "data-name": "Rectangle 2910",
    width: 435.385,
    height: 385.801,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22361",
    "data-name": "Group 22361",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_22360",
    "data-name": "Mask Group 22360",
    transform: "translate(0 -0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21830",
    "data-name": "Path 21830",
    d: "M737.458,193.607H925.334A26.748,26.748,0,0,1,952,220.276V478.534a26.741,26.741,0,0,1-26.667,26.66H737.458a26.746,26.746,0,0,1-26.669-26.66V220.276a26.752,26.752,0,0,1,26.669-26.669",
    transform: "translate(-592.021 -161.256)",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21831",
    "data-name": "Path 21831",
    d: "M775.051,238.729H962.928a19.185,19.185,0,0,1,19.127,19.129V516.116a19.184,19.184,0,0,1-19.127,19.127H775.051a19.185,19.185,0,0,1-19.127-19.127V257.858a19.186,19.186,0,0,1,19.127-19.129",
    transform: "translate(-629.615 -198.839)",
    fill: "#e3e7ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21832",
    "data-name": "Path 21832",
    d: "M782.168,244.555,968.56,229.881l20.908,265.6-186.4,14.674Z",
    transform: "translate(-651.473 -191.469)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21833",
    "data-name": "Path 21833",
    d: "M884.539,348.726l161.005-13.446,1.694,21.57L886.232,370.3Z",
    transform: "translate(-736.739 -279.257)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21834",
    "data-name": "Path 21834",
    d: "M909,590.652l148.516-11.963c1.936-.157,3.342,1.371,3.81,3.266a3.666,3.666,0,0,1-3.257,3.813L909.554,597.731c-1.936.148-4.428-1.407-3.812-3.256v-.01c.618-1.851,1.309-3.658,3.259-3.813m.989,12.612,102.473-8.339a3.551,3.551,0,1,1,.556,7.081l-102.473,8.329a3.547,3.547,0,1,1-.557-7.071",
    transform: "translate(-754.319 -481.985)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21835",
    "data-name": "Path 21835",
    d: "M913.548,844.3l21.24-1.667,1.667,21.232-21.232,1.676Z",
    transform: "translate(-760.901 -701.835)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21836",
    "data-name": "Path 21836",
    d: "M1124.557,794.113l115.279-9.079a3.551,3.551,0,0,1,.557,7.081l-115.269,9.077a3.551,3.551,0,0,1-.567-7.078m1,12.6,69.232-5.447a3.551,3.551,0,0,1,.558,7.081l-69.235,5.446a3.551,3.551,0,1,1-.554-7.08",
    transform: "translate(-933.931 -653.851)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21837",
    "data-name": "Path 21837",
    d: "M929.821,1050.656l21.232-1.667,1.678,21.23-21.243,1.677Z",
    transform: "translate(-774.455 -873.709)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21838",
    "data-name": "Path 21838",
    d: "M1140.823,1000.464l115.268-9.077a3.551,3.551,0,1,1,.557,7.081l-115.267,9.077a3.551,3.551,0,0,1-.557-7.081m.989,12.6,69.236-5.445a3.55,3.55,0,0,1,.557,7.077l-69.238,5.449a3.551,3.551,0,0,1-.555-7.081",
    transform: "translate(-947.476 -825.724)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21839",
    "data-name": "Path 21839",
    d: "M946.058,1257l21.239-1.668,1.669,21.232-21.232,1.676Z",
    transform: "translate(-787.978 -1045.572)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21840",
    "data-name": "Path 21840",
    d: "M1157.043,1206.8l115.279-9.077a3.551,3.551,0,0,1,.557,7.081l-115.279,9.079a3.553,3.553,0,0,1-.557-7.083m.993,12.606,69.235-5.447a3.55,3.55,0,1,1,.557,7.079l-69.228,5.449a3.552,3.552,0,1,1-.564-7.081",
    transform: "translate(-960.989 -997.587)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21841",
    "data-name": "Path 21841",
    d: "M962.316,1463.35l21.228-1.667,1.668,21.231-21.229,1.677Z",
    transform: "translate(-801.52 -1217.445)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21842",
    "data-name": "Path 21842",
    d: "M1173.291,1413.148l115.268-9.079a3.551,3.551,0,1,1,.557,7.08l-115.268,9.08a3.551,3.551,0,1,1-.557-7.081m.989,12.6,69.238-5.446a3.55,3.55,0,0,1,.555,7.078l-69.238,5.446a3.55,3.55,0,0,1-.555-7.078",
    transform: "translate(-974.515 -1169.45)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21843",
    "data-name": "Path 21843",
    d: "M978.53,1669.693l21.232-1.668,1.677,21.23-21.232,1.676Z",
    transform: "translate(-815.025 -1389.309)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21844",
    "data-name": "Path 21844",
    d: "M1189.53,1619.5l115.279-9.077a3.55,3.55,0,0,1,.557,7.078l-115.28,9.077a3.55,3.55,0,0,1-.555-7.078m.993,12.606,69.233-5.446a3.55,3.55,0,1,1,.557,7.078l-69.233,5.446a3.55,3.55,0,0,1-.557-7.078",
    transform: "translate(-988.045 -1341.323)",
    fill: "#c7dcf5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21845",
    "data-name": "Path 21845",
    d: "M1112.218,20.585h33.045V13.627a13.626,13.626,0,1,1,27.252,0v6.958h33.049a8.265,8.265,0,0,1,8.232,8.236V44.51a8.263,8.263,0,0,1-8.232,8.235h-93.346a8.264,8.264,0,0,1-8.236-8.235V28.821a8.265,8.265,0,0,1,8.236-8.236m46.676-12.449a6.029,6.029,0,1,1-6.029,6.029,6.026,6.026,0,0,1,6.029-6.029",
    transform: "translate(-919.515 0.003)",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21846",
    "data-name": "Path 21846",
    d: "M909.452,802.987a2.282,2.282,0,1,1,3.647-2.745l8.114,10.824,19.155-19.408a2.288,2.288,0,1,1,3.265,3.206L922.6,816.156a2.6,2.6,0,0,1-.254.225,2.285,2.285,0,0,1-3.2-.461Z",
    transform: "translate(-757.108 -658.807)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21847",
    "data-name": "Path 21847",
    d: "M925.668,1009.333a2.284,2.284,0,0,1,3.651-2.746l8.113,10.818,19.164-19.4a2.285,2.285,0,1,1,3.258,3.2L938.828,1022.5a1.93,1.93,0,0,1-.257.227,2.286,2.286,0,0,1-3.2-.461Z",
    transform: "translate(-770.617 -830.676)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21848",
    "data-name": "Path 21848",
    d: "M941.892,1215.671a2.288,2.288,0,0,1,3.659-2.746l8.113,10.818,19.154-19.4a2.285,2.285,0,1,1,3.258,3.2l-21.023,21.294a2.429,2.429,0,0,1-.26.217,2.279,2.279,0,0,1-3.2-.452Z",
    transform: "translate(-784.129 -1002.535)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21849",
    "data-name": "Path 21849",
    d: "M958.169,1422.023a2.282,2.282,0,1,1,3.646-2.746l8.113,10.824,19.164-19.406a2.286,2.286,0,0,1,3.259,3.206l-21.022,21.293c-.086.078-.168.156-.26.224a2.287,2.287,0,0,1-3.2-.46Z",
    transform: "translate(-797.683 -1174.407)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21850",
    "data-name": "Path 21850",
    d: "M217.7,2080.2c-120.23,0-217.7,8.555-217.7,19.1s97.466,19.11,217.7,19.11,217.689-8.557,217.689-19.11-97.46-19.1-217.689-19.1",
    transform: "translate(0 -1732.611)",
    fill: "#e3e7ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21882",
    "data-name": "Path 21882",
    d: "M329.709,514.326c1.676.114,3.293-1.867,3.762-2.468a21.249,21.249,0,0,0,3.37-6.4c-.347-.988-.7-2.237-1.085-3.75q-9.683-6.583-2.65-9.737c.943.527,2.121,2.162,3.517,4.9a2.884,2.884,0,0,0,2.546-1.712,85.152,85.152,0,0,1-2.6-11.249c3.18-4.735,10.618-5.407,20.467-4.126.46,2.623.834,5.391,1.129,8.33,1.735,1.6,1.514,7.548-.088,14.412q1.2,5.836-7.225,6.375c-.053.948.037,2.026.05,2.685.02.6.035,1.764.66,1.946l1.043.262c-.1,13.941-7.244,16.618-22.9.538",
    transform: "translate(-274.617 -399.135)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21883",
    "data-name": "Path 21883",
    d: "M322.5,412.936c-9.849-1.28-17.287-.6-20.467,4.126a85.463,85.463,0,0,0,2.6,11.249,2.884,2.884,0,0,1-2.546,1.711c-1.4-2.736-2.574-4.372-3.517-4.9q-7.037,3.15,2.651,9.738a38.574,38.574,0,0,0,1.093,3.75c-5.813-1.3-10.668-6.495-11.354-8.746-6.777-13.353.782-18.989,4.82-21.048,1.791-13.223,21.066-1.791,26.133-9.861,10.615,6.055,3.578,13.857.59,13.979",
    transform: "translate(-240.083 -332.294)",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21884",
    "data-name": "Path 21884",
    d: "M417.516,648.775a16.619,16.619,0,0,0,6.48,1.354,18.866,18.866,0,0,0,.043,2.661,10.209,10.209,0,0,1-6.523-4.015",
    transform: "translate(-347.752 -540.369)",
    fill: "#f08261",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21885",
    "data-name": "Path 21885",
    d: "M196.57,2181.17c-6.115-2.154-6.61-5.306-9.9-6.845-3.323-1.545-3.708-4.308-.459-7.3,2.4,1.911,5.377,4.265,6.947,3.023,1.051-.833,4.621-.781,5.324.434,3.113,7.218,7.437,4.933,8.288,8.218.1,4.379-7.39,3.465-10.2,2.474",
    transform: "translate(-153.224 -1804.927)",
    fill: "#240046",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21886",
    "data-name": "Path 21886",
    d: "M450.308,2161.761c-10.773-.174-18.827-.3-22.552-1.477-4.014-1.268-3.18-3.717-.875-7.636,10.152,4.673,7.451-.956,12.2-.243q5,4.025,14.827,5.405c2.764,2.039,1.643,3.863-3.6,3.951",
    transform: "translate(-353.943 -1792.7)",
    fill: "#240046",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21887",
    "data-name": "Path 21887",
    d: "M175.462,683.413a74.007,74.007,0,0,0-14.49-2.842q-1.162,17.736-18.492-.241c-11.13.938-13.31,1.076-19.486,3.083-13.353,12.762-14.585,27.486-21.57,44.321a47.363,47.363,0,0,1,16.462,3.147q1.692-6.048,2.833-9.74-.328,33.293-.244,45.615c25.567,10.138,46.633,6.663,55.232-1.222q.182-29.595.494-46.86a56.564,56.564,0,0,0,8.507,8.393c6.269-7.195,10.517-10.086,14.072-14.326-7.872-12.917-19.146-24.943-23.317-29.328",
    transform: "translate(-84.476 -566.651)",
    fill: "#1d3354",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21888",
    "data-name": "Path 21888",
    d: "M661.236,772.071q-20.16,8.367-28.218,13.831l-2.389-3.537c-2.225,2.234-4.764,4.415-7.852,7.586a42.593,42.593,0,0,0,9.5,7.531q14.011-1.5,30.953-21.206,5.276-1.052,7.758-3.813.129-2.542-2.555-5.1,7.019-4.573,5.6-6.549-11.013,6.8-12.8,11.256",
    transform: "translate(-518.715 -633.688)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21889",
    "data-name": "Path 21889",
    d: "M233.218,1190.251c-.5,1.919,1.59,13.185,1.936,19.067,3.4,20.977.488,48.292-1.346,83.422-3.274,12.371-8.113,28.867-7.791,52.077-5.709,1.748-7.772,1.929-12.927.618-3.6-24.228-1.134-43.627,2.111-52.593-2.085-13.846-5.193-29.343-9.72-51.7-5.1,24.366-11.92,42.445-14.873,54.251-.582,13.153-3.247,30.908-4.638,53.262a23.827,23.827,0,0,1-11.269,1.1c-5.7-20.544-4.742-42.905-2.326-67.073,2.571-29.048-1.668-61.859,2.578-73.233,2.166-6.74,2.451-12.725,3.033-17.964q32,10.646,55.232-1.232",
    transform: "translate(-141.988 -991.368)",
    fill: "#240046",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21890",
    "data-name": "Path 21890",
    d: "M219.276,869.745c-1.361.206-2.658.382-3.88.547q-.1,14.685-.045,21.994a16.434,16.434,0,0,0,4.233,1.33c0-.634-.212-2.084-.212-2.7q-.131-11.232-.087-21.169ZM281.8,850.137q-5.64-4.7-10.745-15.28a59.694,59.694,0,0,1,.451,9.859,54.864,54.864,0,0,0,8.08,7.87q1.145-1.315,2.214-2.449m-61.452-19.095q-2.488,8.018-4.75,15.628-.066,6.436-.115,12.085c1.1-.105,2.381-.174,3.911-.211q.234-15.623.955-27.5",
    transform: "translate(-179.353 -692.18)",
    fill: "#00296b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21891",
    "data-name": "Path 21891",
    d: "M402.136,877h28.153a1.955,1.955,0,0,1,1.973,2.346l-6.316,39.882a2.874,2.874,0,0,1-2.719,2.345H395.08a1.963,1.963,0,0,1-1.98-2.345l6.315-39.882a2.869,2.869,0,0,1,2.72-2.346",
    transform: "translate(-327.393 -730.459)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21892",
    "data-name": "Path 21892",
    d: "M110.691,964.875a35.46,35.46,0,0,0-.728,15.436c3.036,4.415,15.3,1.946,46.865-3.326,1.132,1.032,3.473,2.058,7.027,1.6,3.3-.825,3.46-1.686,7.161-5.177q1.354-4.079-.547-6.22c-4.17,2.452-6.371,3.751-11.07,3.91q1.881-4.824.566-6.229a9.311,9.311,0,0,0-3.127,5.794c-24.892-1.076-31.449-.937-34.767.8.365-1.562.68-2.935.955-4.116a43.946,43.946,0,0,0-12.334-2.467",
    transform: "translate(-91.146 -803.642)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21893",
    "data-name": "Path 21893",
    d: "M241.18,2118.675a25.185,25.185,0,0,1,.1,5.69c8.5,3.691,7.058-.57,10.452-.675a14.855,14.855,0,0,1-1.659-5.752c-3.7,1.061-5.815,1.295-8.9.738m-39.595,3.893a16.233,16.233,0,0,1-.454,4.066c2.269,1.79,4.883,3.664,6.325,2.528a5.48,5.48,0,0,1,3.8-.418,42.4,42.4,0,0,1-1.3-6.977,22.087,22.087,0,0,1-8.373.8",
    transform: "translate(-167.523 -1764.044)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21894",
    "data-name": "Path 21894",
    d: "M235.153,1304.361q-22.513,20.98-60.2.129c-4.247,11.374,0,44.185-2.578,73.233-2.416,24.168-3.373,46.529,2.326,67.073.47.061.912.1,1.348.139a22.087,22.087,0,0,0,8.373-.8c.5-.129,1.008-.277,1.547-.442,1.39-22.354,4.056-40.109,4.638-53.261,2.953-11.806,9.772-29.885,14.873-54.251,4.527,22.362,7.635,37.859,9.72,51.7-3.245,8.966-5.707,28.365-2.111,52.593.939.241,1.781.425,2.555.564,3.082.557,5.2.322,8.9-.738.471-.138.955-.277,1.476-.444-.322-23.21,4.517-39.707,7.791-52.077,1.834-35.13,4.744-62.445,1.346-83.422",
    transform: "translate(-141.988 -1086.411)",
    fill: "#212121",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageRegisterOrderIconImage);
export default __webpack_public_path__ + "static/media/home-page_register-order-icon-image.245304a7c6a513a61467007e4b228896.svg";
export { ForwardRef as ReactComponent };